export default "__VITE_ASSET__56a1e08b__"